import React, { useState, useEffect } from 'react';
import CarouselSlide from '@/components/CarouselSlide';
import { useTranslation } from 'react-i18next';

const HeroCarousel = () => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);

  const desktopImages = [
    { src: "/images/home/carrusel/Slide (0).webp", alt: t('hero.desktopImage1.alt') },
    { src: "/images/home/carrusel/Slide (1).webp", alt: t('hero.desktopImage2.alt') },
    { src: "/images/home/carrusel/Slide (2).webp", alt: t('hero.desktopImage3.alt') },
    { src: "/images/home/carrusel/Slide (3).webp", alt: t('hero.desktopImage4.alt') },
    { src: "/images/home/carrusel/Slide (4).webp", alt: t('hero.desktopImage5.alt') }
  ];

  const mobileImages = [
    { src: "/images/home/carrusel/moviles/Slidem (0).webp", alt: t('hero.mobileImage1.alt') },
    { src: "/images/home/carrusel/moviles/Slidem (1).webp", alt: t('hero.mobileImage2.alt') },
    { src: "/images/home/carrusel/moviles/Slidem (2).webp", alt: t('hero.mobileImage3.alt') },
    { src: "/images/home/carrusel/moviles/Slidem (3).webp", alt: t('hero.mobileImage4.alt') },
    { src: "/images/home/carrusel/moviles/Slidem (4).webp", alt: t('hero.mobileImage5.alt') }
  ];

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    const handleMediaQueryChange = (e) => setIsMobile(e.matches);

    setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleMediaQueryChange);

    return () => {
      mediaQuery.removeEventListener('change', handleMediaQueryChange);
    };
  }, []);

  const images = isMobile ? mobileImages : desktopImages;
  const firstSlideSrc = images[0].src;

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = firstSlideSrc;
    link.setAttribute('fetchpriority', 'high');
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, [firstSlideSrc]);
  // Duplicamos solo la primera imagen al final para un bucle suave con pausas
  const loopedImages = [...images, images[0]];
  const slideCount = loopedImages.length;
  const slideWidth = 100 / slideCount;

  // Calculamos los porcentajes de los keyframes dinámicamente
  const totalImages = images.length;
  const step = 100 / totalImages;
  const pause = step * 0.9; // 90% de pausa, 10% de transición

  let keyframes = '@keyframes slidy {\n';
  for (let i = 0; i < totalImages; i++) {
    const start = i * step;
    const end = start + pause;
    const translate = i * slideWidth;
    keyframes += `  ${start}% { transform: translateX(-${translate}%); }\n`;
    keyframes += `  ${end}% { transform: translateX(-${translate}%); }\n`;
  }
  keyframes += `  100% { transform: translateX(-${totalImages * slideWidth}%); }\n`;
  keyframes += '}';

  return (
    <div className="relative w-full h-auto overflow-hidden bg-neutral-800">
      <style>{`
        .slider-figure {
          position: relative;
          width: ${slideCount * 100}%;
          margin: 0;
          left: 0;
          font-size: 0;
          animation: 25s slidy infinite linear;
          height: 80vh; /* Altura del carrusel en pantallas grandes */
          max-height: 800px; /* Altura máxima para pantallas muy grandes */
          min-height: 500px; /* Altura mínima para pantallas grandes */
          display: flex;
          will-change: transform;
          transform: translateZ(0);
          backface-visibility: hidden;
          perspective: 1000px;
        }
        
        .slider-figure img {
          width: ${slideWidth}%;
          height: 100%; /* Ocupa toda la altura del contenedor */
          object-fit: cover; /* Cubre todo el contenedor recortando la imagen si es necesario */
          object-position: center;
          display: inline-block;
          aspect-ratio: 16 / 9;
        }
        
        ${keyframes}

        @media (max-width: 768px) {
          .slider-figure {
            height: 60vh; /* Altura reducida para móviles */
            min-height: 300px; /* Altura mínima para móviles */
            max-height: 500px; /* Altura máxima para móviles */
          }
          
          .slider-figure img {
            object-fit: cover; /* Cubre todo el contenedor en móviles también */
            object-position: center; /* Centra la imagen para mejor recorte */
          }
        }
      `}</style>

      <figure className="slider-figure">
        {loopedImages.map((image, index) => (
          <CarouselSlide
            key={index}
            src={image.src}
            alt={image.alt}
            eager={index === 0}
            width="1920"
            height="1080"
          />
        ))}
      </figure>
    </div>
  );
};

export default HeroCarousel;
